import ChangePassComponent from '@components/change-pass';
import * as React from 'react';

export interface IChangePassProps {}

export default function ChangePass(props: IChangePassProps) {
  return <ChangePassComponent />;
}
